import {useInfiniteQuery} from 'react-query';
import {getMyPosts} from 'services/myAd/myPost';

interface GetMyWantedParams {
  profile_type: 'farmer' | 'market';
}
const useGetMyPost = (params: GetMyWantedParams) => {
  const {
    data: MyPosts,
    isLoading,
    refetch,
    fetchNextPage,
  } = useInfiniteQuery(
    ['MyPosts', params.profile_type],
    ({pageParam = 1, queryKey}) => getMyPosts(pageParam, queryKey[1]),
    {
      getNextPageParam: (lastPage, allPages) => {
        const lastRecord = allPages[allPages.length - 1]?.next || '';
        return lastRecord
          ? new URL(lastRecord).searchParams.get('page')
          : undefined;
      },
    },
  );
  return {MyPosts, isLoading, refetch, fetchNextPage};
};

export default useGetMyPost;
